module.exports = __webpack_public_path__ + "img/farzana-christopher-84.4cc12b56.jpg";